import { render, staticRenderFns } from "./LoginAsTool.vue?vue&type=template&id=318e9004&scoped=true&"
import script from "./LoginAsTool.vue?vue&type=script&lang=js&"
export * from "./LoginAsTool.vue?vue&type=script&lang=js&"
import style0 from "./LoginAsTool.vue?vue&type=style&index=0&id=318e9004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e9004",
  null
  
)

export default component.exports